/**
 * Children Category Tab Component
 * Reusable tab content for different child categories
 */
import { Card, CardContent } from "@/components/ui/card";
import { ChildCard } from "./ChildCard";

const categoryConfig = {
  all: { emptyText: "No children found", emptyBorder: "border-[#2F6DB5]/30" },
  full_time: { emptyText: "No full time children", emptyBorder: "border-[#2F6DB5]/30" },
  part_time: { emptyText: "No part time children", emptyBorder: "border-[#E83E8C]/30" },
  school_age: { emptyText: "No school age children", emptyBorder: "border-[#F4A623]/30" },
  after_school: { emptyText: "No after school children", emptyBorder: "border-[#4DA3D9]/30" },
  uncategorized: { emptyText: "No uncategorized children", emptyBorder: "border-[#64748B]/30" }
};

export const ChildrenCategoryTab = ({
  children,
  category,
  onEdit,
  onDelete,
  onMismatchCleared,
  selectMode,
  selectedChildren,
  onToggleSelect,
  canEdit = false,
  pendingApprovals = [],
  stillHereChildIds = new Set(),
  schoolsList = null,
  plannerRooms = []
}) => {
  const config = categoryConfig[category] || categoryConfig.all;

  if (children.length === 0) {
    return (
      <Card className={`bg-white/80 backdrop-blur-sm border-2 ${config.emptyBorder}`}>
        <CardContent className="p-8 text-center">
          <p className="text-[#2F6DB5]">{config.emptyText}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid gap-4">
      {children.map((child) => (
        <ChildCard
          key={child.id}
          child={child}
          onEdit={onEdit}
          onDelete={onDelete}
          onMismatchCleared={onMismatchCleared}
          selectMode={selectMode}
          isSelected={selectedChildren.has(child.id)}
          onToggleSelect={onToggleSelect}
          canEdit={canEdit}
          pendingApprovals={pendingApprovals.filter(p => p.childId === child.id)}
          isStillHere={stillHereChildIds.has(child.id)}
          schoolsList={schoolsList}
          plannerRooms={plannerRooms}
        />
      ))}
    </div>
  );
};

export default ChildrenCategoryTab;
